import { type App } from 'vue'
import MobileBreak from '@/components/utils/MobileBreak.vue'

export default {
  install: (app: App) => {
    app.component('mbr', MobileBreak)
  },
}
